module.exports = __webpack_public_path__ + "static/media/homeVN.c6011c57.png";